import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var SiteHeaderDefaultState = {
  isUtilityMenuVisible: false,
  isLangMenuVisible: false,
  isThemeModeMenuVisible: false,
  isShareMenuVisible: false,
  isFollowMenuVisible: false,
  isUserMenuVisible: false,
  isMenuBarVisible: false,
  isNavigationMenuVisible: false,
  isPinnedNavigationMenuVisible: false,
  isContactUsMenuVisible: false,
  disclosedMenuItem: '',
  isLinearNavigationMenuVisible: false
};
export var defaultSiteHeaderConfig = {
  defaultState: SiteHeaderDefaultState
};
export var SiteHeaderContext = React.createContext(defaultSiteHeaderConfig);
export var SiteHeaderProvider = createInheritedProvider(SiteHeaderContext);